import { useState, useCallback } from 'react'

/**
 * Hook for managing line item selection state
 */
export function useLineItemSelection() {
	const [ selectedLineItemIds, setSelectedLineItemIds ] = useState<string[]>( [] )
	const [ selectionVersion, setSelectionVersion ] = useState( 0 )

	const handleSelectLineItem = useCallback( ( lineItemId: string, isSelected: boolean ) => {
		if ( isSelected ) {
			setSelectedLineItemIds( ( prev ) => [ ...prev, lineItemId ] )
		} else {
			setSelectedLineItemIds( ( prev ) => prev.filter( ( itemId ) => itemId !== lineItemId ) )
		}
	}, [] )

	const clearSelection = useCallback( () => {
		setSelectedLineItemIds( [] )
		setSelectionVersion( ( prev ) => prev + 1 )
	}, [] )

	return {
		selectedLineItemIds,
		selectionVersion,
		handleSelectLineItem,
		clearSelection,
	}
}
